// extracted by mini-css-extract-plugin
export default {"textInputLabel":"fS-z","textInput":"gS-z","error":"hS-z","disabled":"iS-z"};